export function excludeProperties(obj, ...keysToExclude) {
    const { [keysToExclude[0]]: _, [keysToExclude[1]]: __, ...rest } = obj;
    return rest;
}
